import React, { useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { NavLink } from "react-router-dom";
import "./SystemLogsDetails.css";

const SystemLogsDetails = () => {
    const { t } = useTranslation();
    const [contentEn, setContentEn] = useState("");
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [logs, setLogs] = useState([]);

    // Fetch system logs
    // Parse log line
const parseLogLine = (line) => {
    const match = line.match(/^\[(.*?)\]\s+(\S+)\.(\w+):\s+(.*)$/);
  
    if (!match) {
      return {
        timestamp: "",
        level: "INFO",
        message: line
      };
    }
  
    return {
      timestamp: match[1],
      level: match[3].toUpperCase(),
      message: match[4]
    };
  };
  
    const fetchSystemLogs = async (url) => {
        setLoading(true);
        let page = 1;
        if (url !== '') {
            const temp = url.split('?page=');
            page = temp[1];
        }
        try {
            const token = localStorage.getItem("userToken");
            const response = await fetch(`${api_url}/logs?page=${page}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                showToast(t("failedtofetchdata"), "error");
                return;
            }
            
            const data = await response.json();
            
            if (data.data) {
                const parsedLogs = data.data.map(logLine => parseLogLine(logLine));
                setLogs(parsedLogs); 
                setLinks(data.links);
            } else {
                showToast(t("nosystemlogsfound"), "warning");
            }
            
            } catch (err) {
                showToast(t("errorfetchingdata"), "error");
            } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSystemLogs('');
    }, []);

    return (
        <div className="py-4 d-flex flex-column">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center flex-grow-1">
            <div className="spinner-border" role="status" style={{ borderTopColor: "#6897CB" }}></div>
          </div>
        ) : (
          <div className="container">
            <h5 className="mb-3">{t("systemlogs")}</h5>
      
            <div className="log-table-wrapper">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Log Level</th>
                    <th>Timestamp</th>
                    <th>Log Message</th>
                  </tr>
                </thead>
                <tbody>
                  {logs && logs.length > 0 ? (
                  logs.map((log, index) => (
                    <tr key={index}>
                      <td>
                        <span className={
                          log.level === "WARNING"
                            ? "text-warning"
                            : log.level === "ERROR"
                            ? "text-danger"
                            : "text-primary"
                        }>
                          {log.level}
                        </span>
                      </td>
                      <td>{log.timestamp}</td>
                      <td>{log.message}</td>
                    </tr>
                  ))
                  
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">No logs available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
      
            {/* Pagination */}
            <div className="navigationWrapper">
              <ul>
                {links.map((link, index) => (
                  <li  
                    key={index}
                    className={`${link.active ? " active " : ""} ${link.url === null ? " disabled " : ""}`}
                    onClick={link.url !== null ? () => fetchSystemLogs(link.url) : undefined}
                  >
                    <div dangerouslySetInnerHTML={{ __html: link.label }} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
      
    );
};

export default SystemLogsDetails;
